export const sortByString = <T>(array: T[], key: keyof T) => {
    return array.sort((a, b) =>
        (a[key] as string).localeCompare(b[key] as string)
    )
}

export const formatDocument = (document: string): string => {
    if (!document) return '-'

    const cleanDocument = document.replace(/\D/g, '')

    if (cleanDocument.length === 11) {
        // CPF: 000.000.000-00
        return cleanDocument.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/,
            '$1.$2.$3-$4'
        )
    }
    if (cleanDocument.length === 14) {
        // CNPJ: 00.000.000/0000-00
        return cleanDocument.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            '$1.$2.$3/$4-$5'
        )
    }

    return document
}
